import { CustomBox } from "components/Box/CustomBox";
import React from "react";
import { fontSize, iconStyle } from "../CustomerView";
import RegularButton from "components/CustomButtons/Button";
import { useSelector } from "react-redux";
import { useHandleView } from "../useHandleView";
import { CreditCard } from "@material-ui/icons";

export const CustomerCreditConditions = () => {
  const { customer } = useSelector(
    ({ customersReducer }) => customersReducer
  );
  const selectView = useHandleView(6);
  const handleNewCondition = () => selectView();
  return (
    <CustomBox
      title="Condiciones de Credito"
      icon={<CreditCard style={{...iconStyle, color: `${customer?.isCreditSuspended === 1 ? '#f6685e': ''}`}} />}
      bg={<CreditCard style={{ ...iconStyle, fontSize, color: `${customer?.isCreditSuspended === 1 ? '#f6685e': ''}` }} />}
    >
      <RegularButton
        size="sm"
        color="info"
        fullWidth
        onClick={handleNewCondition}
      >
        Ver
      </RegularButton>
    </CustomBox>
  );
};
